import React from "react"
import { Box } from "@mui/material"

/**
 * ============================================================================
 * SECTION SEPARATOR FIELD
 * ============================================================================
 *
 * Purpose:
 *
 * Creates visual separation between groups of fields without showing a title.
 *
 * Useful for:
 *
 * - Breaking large forms into smaller groups
 * - Creating spacing between related inputs
 * - Separating subsections inside a section-header
 *
 * ============================================================================
 *
 * Supported Variants
 *
 * default
 * divider
 * spacer
 * dashed
 * thick
 * subtle
 *
 * ============================================================================
 *
 * Example
 *
 * {
 *   "name": "separator_1",
 *   "slug": "separator_1",
 *   "details": {
 *     "type": "section-separator",
 *     "formatting": {
 *       "variant": "divider"
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * ------------------------
 *
 * ============================================================================
 *
 * {
 *   "name": "separator_2",
 *   "slug": "separator_2",
 *   "details": {
 *     "type": "section-separator",
 *     "formatting": {
 *       "variant": "spacer"
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * (empty spacing)
 *
 * ============================================================================
 */

const SectionSeparatorField = ({ variant = "default" }) => {
    return (
        <Box
            className={`e-afm-section-separator-field e-afm-section-separator-field--${variant}`}
        />
    )
}

export default React.memo(SectionSeparatorField)
